import {
  ReactElement, memo, useEffect, useRef, useState,
} from 'react';
import { FullProg_v4 } from '~/providers/types';
import { DamReferenceEcoMode } from './EcoMode';
import { DamScheduleList } from '../SchedulesModals/DAM/components/ScheduleList';
import { DamVentilationForm } from '../SchedulesModals/DAM/components/VentilationForm';
import { DEFAULT_DAM_FULL_PROG } from './constants';

interface EditDevInfoAutomationDAMProps {
  damId: string;
  lastProg: FullProg_v4 | undefined;
  onChange: (prog: FullProg_v4) => void;
  ecoMode?: string | null;
  disabled?: boolean;
  pendingProg?: boolean;
  canManage?: boolean;
}

export const EditDevInfoAutomationDAM = memo(({
  damId,
  lastProg,
  ecoMode,
  onChange,
  disabled,
  pendingProg,
  canManage,
}: Readonly<EditDevInfoAutomationDAMProps>): ReactElement => {
  const [prog, setProg] = useState(DEFAULT_DAM_FULL_PROG);
  const [ventilation, setVentilation] = useState({ start: '0', end: '0' });
  const firstReference = useRef<boolean>(false);

  function onSaveProg(newProg: FullProg_v4): void {
    const updated = {
      ...newProg,
      ventTime: {
        begin: Number(ventilation.start),
        end: Number(ventilation.end),
      },
    };
    setProg(updated);
    onChange(updated);
  }

  function onChangeVentilation(values: { start: string, end: string }): void {
    setVentilation(values);
    onChange({
      ...prog,
      ventTime: {
        begin: Number(values.start),
        end: Number(values.end),
      },
    });
  }

  useEffect(() => {
    if (lastProg && !firstReference.current) {
      firstReference.current = true;
      setProg(lastProg);
      setVentilation({
        start: String(lastProg.ventTime?.begin ?? 0),
        end: String(lastProg.ventTime?.end ?? 0),
      });
    }
  }, [lastProg]);

  return (
    <div style={{ marginBottom: 20, width: 'auto' }}>
      <DamReferenceEcoMode
        damId={damId}
        ecoMode={ecoMode}
      />
      <DamVentilationForm
        onChange={onChangeVentilation}
        disabled={disabled}
        defaultValues={ventilation}
      />
      <div style={{ position: 'relative' }}>
        <DamScheduleList
          lastProg={prog}
          onChangeProg={onSaveProg}
          onlyList={!canManage}
          disabled={disabled}
          pendingProg={pendingProg}
          fixed
        />
      </div>
    </div>
  );
});
